<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data :references.sync="formReferences" :model="adjustmentObj" ref="adjustmentRef">
      <template slot="extraDetails" class="mb-3">
        <v-form ref="orderItems">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>{{ $t('message.warehouse.product') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.minQty') }}</th>
                  <th>{{ $t('message.stock.location') }}</th>
                  <th class="text-right">{{ $t('message.stock.onStock') }}</th>
                  <th class="text-right">{{ $t('message.order.qty') }} (+/-)*</th>
                  <th>{{ $t('message.order.batchNo') }}</th>
                  <th class="text-right">{{ $t('message.whOrder.recQty') }} (+/-)</th>
                  <th>{{ $t('message.common.comments') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(element, index) in orderItems" :key="index" class="pt-4">
                  <td width="25%">
                    {{ element.productnumber }} - {{ element.productname }}
                  </td>
                  <td width="9%" class="text-right">
                    {{ element.minstock }}
                  </td>
                  <td width="12%">
                    {{ element.locationname }}
                  </td>
                  <td width="9%" class="text-right">
                    {{ element.onstock }}
                  </td>
                  <td width="9%" class="text-right">
                    {{ element.qty }}
                  </td>
                  <td width="11%">
                    {{ element.adjustorder.batchnumber }}
                  </td>
                  <td width="10%" class="text-right">
                    {{ element.receivedqty }}
                  </td>
                  <td width="16%">
                    {{ element.comments }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../../components/FormTemplate'
import CONSTANTS from '../../../utils/warehouse.json'
export default {
  data () {
    return {
      adjustmentObj: {
        id: 0,
        status: 'draft',
        priority: 'medium'
      },
      fieldsLoading: false,
      loading: false,
      orderItems: [],
      sheetId: 0,
      sheetAdjustmentData: {}
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfWarehouse']),
    statusList () {
      return [{
        name: this.$t('message.common.draft'), id: CONSTANTS.DRAFT
      }, {
        name: this.$t('message.common.inProgress'), id: CONSTANTS.INPROGRESS
      }, {
        name: this.$t('message.common.received'), id: CONSTANTS.RECEIVED
      }]
    },
    formReferences () {
      return {
        title: this.$t('message.whOrder.addAdjustmentOrder'),
        properties: [{
          model: 'orderdate',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.DATEPICKER,
          class: 'lg3 sm6 xs12',
          disabled: true,
          picker: 'datePicker',
          menu: 'dateMenu',
          color: 'primary lighten-1',
          label: this.$t('message.whOrder.orderDate')
        }, {
          model: 'priority',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.$_priorityList,
          disabled: true,
          term: '',
          is_list: true,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.layout.priority'),
          class: 'lg3 sm6'
        }, {
          model: 'warehouseid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfWarehouse,
          disabled: true,
          click: (term) => null,
          term: 'warehouse',
          is_list: false,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.layout.warehouse'),
          class: 'lg3 sm6'
        }, {
          model: 'status',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          items: this.statusList,
          term: '',
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          disabled: true,
          label: this.$t('message.customer.status'),
          class: 'lg3 sm6'
        }, {
          model: 'comments',
          type: this.FORM_TYPE.TEXTAREA,
          label: this.$t('message.common.comments'),
          disabled: true,
          class: 'lg3 sm6'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.adjust_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'back_to_list',
          color: 'error',
          // eslint-disable-next-line
          click: () => this.$router.push('/w_h/ccsheet'),
          label: this.$t('message.common.backToList'),
          to: '/w_h/ccsheet',
          is_show: true
        }]
      }
    }
  },
  mounted () {
    this.sheetId = this.$route.params.sheet_id
    this.$store.dispatch('getWarehouse')
    this.getOrderItemsHandler()
  },
  methods: {
    getOrderItemsHandler () {
      let url = `/ccsheets/create_adjustment_order/${this.sheetId}`
      this.$_executeApi('post', url)
        .then((response) => {
          this.sheetAdjustmentData = response.data
          let { order, orderitems } = response.data
          let transformNumber = { number: { list: ['qty', 'onstock', 'receivedqty'], format: 'replaceDotWithComma' } }
          let items = this.$_formatListModel(orderitems, transformNumber)
          let transformData = { date: { list: ['orderdate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
          order = this.$_formatModel(order, transformData)
          this.orderItems = items
          this.adjustmentObj = order
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.adjustmentRef.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.sheetAdjustmentData
        this.$_saveUpdateHandler('/ccsheets/save_adjustment_order', model)
          .then((response) => {
            this.$router.push('/w_h/ccsheet')
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  }
}
</script>
